var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import "./SubElementComponent";
import { defaults, outlineVariantColor, surfaceColor } from "../style";
let StackElementComponent = class StackElementComponent extends LitElement {
    render() {
        return html `
            <label>${this.label}</label>
            <table>
                ${this.ordered_locals.map((varname) => html `
                    <tr>
                        <td class="key">
                            ${varname}
                        </td>
                        <td class="value">
                            <tc-sub-element .el=${this.locals[varname]}></tc-sub-element>
                        </td>
                    </tr>
                `)}
            </table>
        `;
    }
};
StackElementComponent.styles = [defaults, css `
        :host {
            display: block;
            padding: 8px;
            margin-bottom: 16px;
            background-color: ${surfaceColor};
            border-radius: 5px;
        }
        table {
            margin-left: auto;
        }
        .key {
            text-align: right;
        }
        .value {
            border-left: 1px solid ${outlineVariantColor};
            border-bottom: 1px solid ${outlineVariantColor};
        }
        label {
            font-size: 14px;
            margin-bottom: 4px;
        }
    `];
__decorate([
    property({ type: Array })
], StackElementComponent.prototype, "ordered_locals", void 0);
__decorate([
    property({ type: Object })
], StackElementComponent.prototype, "locals", void 0);
__decorate([
    property({ type: String })
], StackElementComponent.prototype, "label", void 0);
StackElementComponent = __decorate([
    customElement('tc-stack-element')
], StackElementComponent);
export { StackElementComponent };
//# sourceMappingURL=StackElementComponent.js.map